import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        user: null,
        events: [],
        currentEvent: 0,
        eventSelections: {},
        teams: [],
        initialising: true,
        // true while a logout request is in flight; drives the blocking "Logging out…" overlay
        isLoggingOut: false,
        requestsInProgress: 0,
        // banner should be object looking like {type: 'error', text: 'Validation failed. Please fix the error', show: true}
        banner: null,
        // snackbars should use the mixin but be an array of objects that look the same as banner
        // i.e. {type: 'error',text: 'Validation failed. Please fix the error',show: true,}
        snackbars: [],
        // this is compared to the HealthCheck/Version endpoint to see if the app has been updated and shows a
        // banner if so, prompting the user to reload
        version: null,
    },

    actions,
    getters,
    mutations,
})

window.onerror = function(message, source, error) {
    console.error('Javascript error - ' + message)
    let payload = {
        Message: message,
        Source: source,
        Error: error.stack,
    }
    store.dispatch('addErrorLog', payload)
}

api.configureEventHandlers(
    config => store.dispatch('apiRequestStarted', config),
    config => store.dispatch('apiRequestError', config),
    response => store.dispatch('apiResponseReceived', response),
    response => store.dispatch('apiResponseError', response),
)

setInterval(function() {
    store.dispatch('getEvents')
    store.dispatch('getTeams')
}, 1000 * 60 * 5)

Vue.nextTick(async function() {
    await store.dispatch('checkUser')
})

export default store
